import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Route, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ConfirmPassengerNotCheckedInDialogComponent } from 'src/app/components/confirm-passenger-not-checked-in-dialog/confirm-passenger-not-checked-in-dialog.component';
import { EndTaskReasonDialogComponent } from 'src/app/components/my-tasks/end-task-reason-dialog/end-task-reason-dialog.component';
import { MyTaskConfirmationDialogComponent } from 'src/app/components/my-tasks/my-task-confirmation-dialog/my-task-confirmation-dialog.component';
import { MyTasksService } from 'src/app/services/my-tasks.service';
import { MyTasksComponent } from '../../components/my-tasks/my-tasks.component';
import { SharedModule } from '../shared-module/shared.module';
import { TerminalRunsModule } from '../terminal-runs/terminal-runs.module';

const routes: Route[] = [{
  path: 'myTasks',
  component: MyTasksComponent,
  children: [
    {path: 'create', component: MyTasksComponent, outlet: 'side'}
  ]
}];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatExpansionModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollingModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatOptionModule,
    MatIconModule,
    FontAwesomeModule,
    MatDialogModule,
    MatRadioModule,
    TerminalRunsModule,
    MatCardModule,
    SharedModule
  ],
  providers: [MyTasksService],
  declarations: [
    MyTaskConfirmationDialogComponent,
    MyTasksComponent,
    ConfirmPassengerNotCheckedInDialogComponent,
    EndTaskReasonDialogComponent
  ],
  exports:[MyTasksComponent]
})
export class MyTasksModule { }
